<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.states.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div class="ir-plugin-values th-plugin-values">
      <p *ngIf="plugin?.config?.States != -1">
        <span
          >{{ 'plugins.states.status' | translate }}
          <strong class="ir-ph1">{{ plugin?.config?.States | statespipe }}</strong></span
        >
      </p>
      <p *ngIf="impact.isAnyTrue()">
        <span
          >{{ 'plugins.states.impact' | translate }} <strong class="ir-ph1">{{ getImpactValue() }}</strong></span
        >
      </p>
      <p *ngIf="plugin?.config?.Action != -1">
        <span
          >{{ 'plugins.states.actions' | translate }}
          <strong class="ir-ph1">{{ plugin?.config?.Action | actionspipe }}</strong></span
        >
      </p>
      <p *ngIf="plugin?.config?.Criticaly">
        <span
          >{{ 'plugins.states.critical' | translate }}
          <strong class="ir-ph1">{{
            plugin?.config?.Criticaly ? ('plugins.states.yes' | translate) : ('plugins.states.no' | translate)
          }}</strong></span
        >
      </p>
      <p *ngIf="showPriority">
        <span
          >{{ 'plugins.observation.priority' | translate }}
          <strong class="ir-ph1">{{ plugin?.config?.Priority | stateprioritypipe }}</strong></span
        >
      </p>
    </div>
  </div>
</div>
